import { useQuery } from '@tanstack/react-query';
import { getInstallableCatalog, USER_MCP_QUERY_KEYS } from '../../api';

/**
 * `enabled` lets callers (e.g. the chat composer) skip the fetch entirely — the catalog endpoint
 * is feature-flag-gated server-side, so firing it when MCPs aren't in play would 404.
 */
export const useInstallableCatalog = (enabled = true) =>
  useQuery({
    queryKey: USER_MCP_QUERY_KEYS.catalog,
    queryFn: getInstallableCatalog,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
